import React from "react";
import PropTypes from "prop-types";
import { Modal, Container, Row, Col, Button } from "react-bootstrap";
import LoadingOverlay from "../../../../../components/loading-ovelay/loading-overlay";
import UserPhoto from "../../../../../components/user-photo/user-photo";
import TasksDynamicFieldsContent from "../../../../../components/DynamicField/Tasks/ContentViewer/Content";
import TiffViewer from "../TiffViewer/TiffViewer";
import "./DocumentViewerModalNew.scss";

const DocumentViewerModalNew = ({
  showDocFileViewer,
  setShowDocFileViewer,
  setCommentAttachment,
  oneDoc,
  currComment,
  commentViewer,
  setCommentViewer,
  onDownloadingFiles,
  task,
  workItem,
  type,
  assignID,
}) => {
  const isTiffImage =
    oneDoc?.FileName?.toLowerCase().includes(".tif") ||
    oneDoc?.docPath?.toLowerCase().includes(".tif");
  // The audit-trail API returns PascalCase TaskCommentFileDto fields (Id,
  // FileName/Name, FileContentType), but TiffViewer's contract is camelCase
  // (documentID, fileName, mimeType). Without this mapping the download
  // payload loses DocumentId/AttachmentType and the API rejects it with
  // "Posted file expected but not found". documentID maps from Id — the same
  // value the working non-TIFF download path posts as DocumentId. The
  // camelCase fallbacks keep this correct for any caller already passing the
  // canonical shape.
  const tiffSource =
    currComment?.Files?.length === 1 ? currComment.Files[0] : oneDoc;
  const tiffFile = tiffSource && {
    documentID: tiffSource.Id ?? tiffSource.documentID,
    fileName: tiffSource.FileName ?? tiffSource.Name ?? tiffSource.fileName,
    mimeType: tiffSource.FileContentType ?? tiffSource.mimeType ?? "image/tiff",
    uploadDate: tiffSource.UploadDate ?? tiffSource.uploadDate,
    docPath: tiffSource.docPath,
  };
  const isWebpImage =
    oneDoc?.docPath?.toLowerCase().includes(".webp") ||
    oneDoc?.FileName?.toLowerCase().includes(".webp");
  const classPdfViewer = commentViewer
    ? "show-comment-pdf-viewer"
    : "no-comment-pdf-viewer";

  const handleHideModal = () => {
    setShowDocFileViewer(false);
    setCommentAttachment(0);
  };

  const handleDownloadFiles = () => {
    onDownloadingFiles(
      oneDoc.UploadDate ? [oneDoc] : currComment.Files,
      currComment
    );
  };

  const handleToggleCommentViewer = () => {
    setCommentViewer(!commentViewer);
  };

  return (
    showDocFileViewer && (
      <div onClick={(e) => e.stopPropagation()}>
        <Modal
          show={showDocFileViewer}
          backdrop={true}
          onHide={handleHideModal}
          className="single-file-popup-container"
          dialogClassName={
            !commentViewer ? "document-modal-off" : "document-modal"
          }
          scrollable={true}
        >
          <Modal.Header className="single-file-popup-container" closeButton>
            <Modal.Title className="actions-title task-document-viewer">
              Document Viewer
            </Modal.Title>
          </Modal.Header>
          <div className="select-member-divider-line"></div>
          <Modal.Body className="single-attachment-popup">
            <Container>
              <Row>
                <Col>
                  <LoadingOverlay area="pdf-viewer" />
                  <Button
                    className="right-btn btn-wide doc-btn"
                    variant="primary"
                    onClick={handleDownloadFiles}
                  >
                    Download
                  </Button>
                  {commentViewer ? (
                    <Button
                      className="right-btn btn-wide hide-btn btn-outlined doc-btn"
                      variant="primary"
                      onClick={handleToggleCommentViewer}
                    >
                      Hide Comment
                    </Button>
                  ) : (
                    <Button
                      className="right-btn btn-wide hide-btn btn-outlined doc-btn"
                      variant="primary"
                      onClick={handleToggleCommentViewer}
                    >
                      Show Comment
                    </Button>
                  )}
                  {isTiffImage && (
                    <TiffViewer
                      file={tiffFile}
                      taskId={(task?.Id || workItem?.assignID || assignID) ?? 0}
                      type={type}
                      commentViewer={commentViewer}
                    />
                  )}
                  {isWebpImage && (
                    <img
                      className={classPdfViewer}
                      src={oneDoc.docPath}
                      alt="webp file"
                      title="webp file preview"
                    />
                  )}
                  {!isTiffImage && !isWebpImage && (
                    <iframe
                      className={classPdfViewer}
                      src={oneDoc.docPath + "#zoom=Fit"}
                      title="fileName"
                      height="500px"
                      width="100%"
                      allowFullScreen
                    />
                  )}
                </Col>
                {commentViewer && (
                  <Col xs={4}>
                    <Modal.Title className="actions-header show-comment-actions-header">
                      Submitted by
                    </Modal.Title>
                    <div className="comment-box">
                      <div className="comment-title">
                        <UserPhoto
                          name={currComment.CreatedBy?.Name}
                          comments={true}
                          photo={null}
                        />
                        <div className="full-comment-header text-break">
                          {currComment.ExternalEmail ??
                            currComment.CreatedBy?.Name}
                        </div>
                      </div>
                      <div className="comment-body">
                        {currComment?.Note ? (
                          <div
                            className={`text-break full-comment ${
                              currComment.Note.substring(0, 1) === "<"
                                ? "comment-grey-text"
                                : ""
                            }`}
                          >
                            {currComment.Note}
                          </div>
                        ) : (
                          <div className="text-break full-comment">
                            No comment available.
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={"comment-padding"}></div>
                    <TasksDynamicFieldsContent
                      projectTypeId={
                        workItem?.projectTypeID ?? task?.projectTypeID
                      }
                      taskTypeId={workItem?.workItemType ?? task?.workItemType}
                      objectId={currComment.Id}
                      sidePanelStyles={true}
                    />
                  </Col>
                )}
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </div>
    )
  );
};

DocumentViewerModalNew.propTypes = {
  showDocFileViewer: PropTypes.bool.isRequired,
  setShowDocFileViewer: PropTypes.func.isRequired,
  setCommentAttachment: PropTypes.func.isRequired,
  oneDoc: PropTypes.object.isRequired,
  currComment: PropTypes.object.isRequired,
  commentViewer: PropTypes.bool.isRequired,
  setCommentViewer: PropTypes.func.isRequired,
  onDownloadingFiles: PropTypes.func.isRequired,
  task: PropTypes.object,
  workItem: PropTypes.object,
  type: PropTypes.string,
  assignID: PropTypes.number,
};

export default DocumentViewerModalNew;
